import { render, staticRenderFns } from "./notification-activity.vue?vue&type=template&id=8b4cc2fe"
import script from "./notification-activity.vue?vue&type=script&lang=js"
export * from "./notification-activity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports